const CardDots = () => {
  return (
    <>
      <span className="absolute z-10 shadow-[0_3px_6px_0_#00000033] sm:top-2.5 top-1.5 sm:right-2.5 right-1.5 w-2.5 h-2.5 bg-white rounded-full"></span>
      <span className="absolute z-10 shadow-[0_3px_6px_0_#00000033] sm:top-2.5 top-1.5 sm:left-2.5 left-1.5 w-2.5 h-2.5 bg-white rounded-full"></span>
      <span className="absolute z-10 shadow-[0_3px_6px_0_#00000033] sm:bottom-2.5 bottom-1.5 sm:right-2.5 right-1.5 w-2.5 h-2.5 bg-white rounded-full"></span>
      <span className="absolute z-10 shadow-[0_3px_6px_0_#00000033] sm:bottom-2.5 bottom-1.5 sm:left-2.5 left-1.5 w-2.5 h-2.5 bg-white rounded-full"></span>
    </>
  );
};
export default CardDots;
